import React, { useState, useEffect, useRef } from 'react';
import { CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Collapse, Row, Col, Form, Select, Popconfirm } from 'antd';
import Input from '../../ui/Input'
import { getOTACodes } from '../../../services/common'
import Loading from '../../Loading';
import Schedule from './TransportationSchedule';

const { Panel } = Collapse;
const FormItem = Form.Item;

const Option = Select.Option;
interface propsTypes {
    addLoading: void | any,
    validateFieldsError: void | any,
    currentForm: void | any
}
interface dataType {
    type: string,
    typedetail: string,
    inclunded: string,
    description: string,
    charge: '',
    currency: string,
    chargeunit: string,
    schedule: [{
        startDatePicker: string,
        operationtime: [
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },
            {
                dayoftheweek: string,
                starttime: string,
                endtime: string
            },

        ]
    }
    ]
}
let errHandle = false;

const TransportationAdd = (props: propsTypes | any) => {
    const [reftypeData, setReftypeData] = useState<Array<any>>([])
    const [currencyData, setCurrencyData] = useState<Array<any>>([])
    // const [addId,setAddId] = useState(0);
    // const [schedulesId,setSchedulesId] = useState(0);
    const scheduleRef: any = useRef();
    const transportation: any = [{
        type: '',
        typedetail: '',
        inclunded: '',
        description: '',
        charge: '',
        currency: '',
        chargeunit: '',
        schedule: [{
            startDatePicker: '',
            operationtime: [
                {
                    dayoftheweek: "Mon",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Tue",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Wed",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Thu",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Fri",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Sat",
                    starttime: "",
                    endtime: ""
                },
                {
                    dayoftheweek: "Sun",
                    starttime: "",
                    endtime: ""
                },

            ]
        }]
    }]
    const [isRequired, setIsRequired] = useState(true)
    const [refreshCount, setRefreshCount] = useState(0)
    //const [refreshSchedule, setRefreshSchedule] = useState(0)
    const [detailData, setDetailData] = useState(transportation)
    const getDefaultOpenKeys = (detailData: dataType[]) => Array.from(detailData).map((v, k) => k);
    const [defaultOpenKeys, setDefaultOpenKeys] = useState(getDefaultOpenKeys(detailData))
    const addCertification = () => {
        const newDetails = ([{
            type: '',
            typedetail: '',
            inclunded: '',
            description: '',
            charge: '',
            currency: '',
            chargeunit: '',
            schedule: [{
                startDatePicker: '',
                operationtime: [
                    {
                        dayoftheweek: "Mon",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Tue",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Wed",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Thu",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Fri",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Sat",
                        starttime: "",
                        endtime: ""
                    },
                    {
                        dayoftheweek: "Sun",
                        starttime: "",
                        endtime: ""
                    },

                ]
            }
            ]
        }])
        setIsRequired(true)
        const newDetail = JSON.parse(JSON.stringify(detailData)).concat(newDetails)
        setDetailData(newDetail)
        setDefaultOpenKeys(getDefaultOpenKeys(newDetail))
        setRefreshCount(refreshCount + 1)
        // setDefaultSchedule(getDefaultSchedule(newDetail))
        // setRefreshSchedule(refreshSchedule + 1)
    }
    const onChangeItem = () => {
        setIsRequired(true)
    }
    useEffect(() => {
        if (errHandle) {
            props.validateFieldsError();
        } else {
            errHandle = true;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [detailData])
    
    const typeData = async () => {
        let res = await getOTACodes('TRP', '')
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setReftypeData(res.otacodes)
        } else {
            setReftypeData([])
        }
    };
    const currenData = async () => {
        let res = await getOTACodes('CUR', '')
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setCurrencyData(res.otacodes)
        } else {
            setCurrencyData([])
        }
    };

    const deleteItem = (index: number, e: any) => {
        let newDetailData = detailData.filter((item: any) => item)
        if (newDetailData.length === 1) {
            const newDetails = ([{
                type: '',
                typedetail: '',
                inclunded: '',
                description: '',
                charge: '',
                currency: '',
                chargeunit: '',
                schedule: [{
                    startDatePicker: '',
                    operationtime: [
                        {
                            dayoftheweek: "Mon",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Tue",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Wed",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Thu",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Fri",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sat",
                            starttime: "",
                            endtime: ""
                        },
                        {
                            dayoftheweek: "Sun",
                            starttime: "",
                            endtime: ""
                        },

                    ]
                }
                ]
            }])
            props.currentForm.setFieldsValue({ transportation: newDetails })
            scheduleRef.current.resetSchedule();
            setIsRequired(false)
        } else {
            const newValue = detailData ? detailData.map((item: any, _index: number) => {
                if (_index === index && newDetailData.length > 1) {
                    return null;
                }
                return item;
            }) : [];
            setDetailData(newValue);
        }

    }
    useEffect(() => {
        typeData()
        currenData()
    }, [])

    return (props.addLoading ? <Loading type="large" /> :
        <div>
            <Collapse defaultActiveKey={defaultOpenKeys} ghost key={refreshCount}>
                {detailData.map((item: any, i: number) => (

                    <React.Fragment key={i}>
                        {item ? <Panel
                            collapsible="header"
                            className="panel-border"
                            header={`Transportation ${i + 1}`}
                            key={i}
                            extra={
                                <Popconfirm
                                    placement="leftTop"
                                    title={`Are you sure you want to delete Transportation ${i + 1}?`}
                                    onConfirm={(e) => deleteItem(i, e)}
                                    okText="Yes"
                                    cancelText="No">
                                    <CloseCircleOutlined className="panel-btn" />
                                </Popconfirm>
                            }
                        >
                            <Row gutter={24}>
                                <Col span={6}>
                                    <FormItem name={['transportation', i, 'type']} label="Type">
                                        <Select allowClear onChange={onChangeItem} showSearch>
                                            {reftypeData && reftypeData.length ? reftypeData.map((item) => {
                                                return (
                                                    <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                                )
                                            }) : null}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem name={['transportation', i, 'typedetail']} label="Type Detail" rules={[{ max: 2000, message: 'You have reached the max character length of 128' }]}>
                                        <Input maxLength={2000} onChange={onChangeItem} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={6}>
                                    <FormItem name={['transportation', i, 'included']} label="Included">
                                        <Select allowClear onChange={onChangeItem} showSearch>
                                            <Option value="true">Yes</Option>
                                            <Option value="false">No</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem name={['transportation', i, 'description']} label="Description" rules={[{ max: 100, message: 'You have reached the max character length of 100' }]}>
                                        <Input maxLength={100} onChange={onChangeItem} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={6}>
                                    <FormItem name={['transportation', i, 'charge']} label="Charge(Amount)" rules={[{ pattern: /^\d*(\.\d*)?$/, message: 'This field should be a number' }]} >
                                        <Input onChange={onChangeItem} />
                                    </FormItem>
                                </Col>
                                <Col span={6}>
                                    <FormItem name={['transportation', i, 'currency']} label="Currency">
                                        <Select allowClear onChange={onChangeItem} showSearch>
                                            {currencyData && currencyData.length ? currencyData.map((item) => {
                                                return (
                                                    <Select.Option value={item.codeName} key={item.codeName} showSearch>{item.codeName}</Select.Option>
                                                )
                                            }) : null}
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span={6}>
                                    <FormItem name={['transportation', i, 'chargeunit']} label="Charge Unit">
                                        <Select allowClear onChange={onChangeItem} showSearch>
                                            <Option value="One Way">One Way</Option>
                                            <Option value="Round Trip">Round Trip</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <FormItem style={{ marginBottom: '0px' }} name={['transportation', i, 'schedule']}>
                                <Schedule ref={scheduleRef} onChangeItem={onChangeItem} />
                            </FormItem>
                        </Panel> : null}
                    </React.Fragment>
                ))
                }
            </Collapse>
            <Button
                type="link"
                onClick={() => {
                    addCertification()
                }}
                icon={<PlusOutlined />}
                style={{ display: 'flex', alignItems: 'center', background: '#fff', float: 'right' }}
            >
                Add Transportation {detailData.length + 1}
            </Button>
        </div>
    )
}

export default TransportationAdd;

